import React, { Fragment } from 'react';
import ReactApexChart from 'react-apexcharts';
import { FiNavigation } from 'react-icons/fi';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import { Finance } from '../../../Constant';
import { columnChart } from '../../../Data/Widgets/Chart/ChartData';

const FinanceChart = () => {
  return (
    <Fragment>
      <Col xl='5' lg='12' className='box-col-5'>
        <Card>
          <CardHeader className='pb-0'>
            <Row>
              <Col xs='9'>
                <H5>{Finance}</H5>
              </Col>
              <Col xs='3' className='text-end'>
                <FiNavigation style={{ width: '20px', height: '20px' }} className='text-muted' />
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <div className='chart-container'>
              <div id='columnchart'>
                <ReactApexChart options={columnChart.options} series={columnChart.series} height='350' type='bar' />
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default FinanceChart;
